import React from 'react';
import { useDispatch } from 'react-redux';

import { Field } from '@gumtree/ui-library';
import { formatFieldValue } from '../../shared/price-helper';
import type { FilterData, FilterKey } from '../../../types';
import { setSingleFilterState } from '../../../reducers/current-filter-states';
import { StyledTo } from './index.style';

export const RangedFreeform = ({
    filterKey,
    minKey,
    maxKey,
    currentMinValue,
    currentMaxValue,
    handleUpdateButtonClick,
    isStateful,
}: {
    filterKey: FilterKey;
    minKey: NonNullable<FilterData['minKey']>;
    maxKey: NonNullable<FilterData['maxKey']>;
    currentMinValue: string | undefined;
    currentMaxValue: string | undefined;
    handleUpdateButtonClick: Function;
    isStateful: boolean;
}) => {
    const dispatch = useDispatch();

    const onChange = (e, dispatch: (value: string) => void) => {
        const rawValue = e.target.value;
        const sanitisedValue = rawValue.toString().replace('£', '').replaceAll(',', '');

        const isBreachingCharacterLimit = sanitisedValue.length > 9;
        if (isBreachingCharacterLimit) {
            return;
        }

        const isClearingAllCharacters = !e.nativeEvent.data;
        if (isClearingAllCharacters) {
            dispatch('');
            return;
        }
        if (rawValue && isNaN(sanitisedValue)) {
            return;
        }

        dispatch(sanitisedValue);
    };

    const onKeyDown = (evt) => {
        if (evt.keyCode === 13) {
            handleUpdateButtonClick();
        }
    };

    return (
        <>
            <Field
                id={`filter-freeform-${filterKey}-from`}
                label={isStateful ? 'Min.' : ''}
                placeholder="min"
                inputMode="decimal"
                value={formatFieldValue(currentMinValue)}
                onKeyDown={onKeyDown}
                onInput={(e) =>
                    onChange(e, (value) => {
                        dispatch(setSingleFilterState({ key: minKey, value }));
                    })
                }
            />
            {isStateful && <StyledTo>to</StyledTo>}
            <Field
                id={`filter-freeform-${filterKey}-to`}
                label={isStateful ? 'Max.' : ''}
                placeholder="max"
                inputMode="decimal"
                value={formatFieldValue(currentMaxValue)}
                onKeyDown={onKeyDown}
                onInput={(e) =>
                    onChange(e, (value) => {
                        dispatch(setSingleFilterState({ key: maxKey, value }));
                    })
                }
            />
        </>
    );
};
